import { useCallback } from "react";

const useScrollHelper = () => {
  // Method to scroll to the top of the page
  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // This ensures smooth scrolling
    });
  }, []);

  // Method to scroll to an element by its id
  const scrollToElementById = useCallback((id: string) => {
    const elementId = id.startsWith("#") ? id.substring(1) : id;
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth", // This ensures smooth scrolling
        block: "start", // Aligns the element to the top of the viewport
      });
    }
  }, []);

  return { scrollToTop, scrollToElementById };
};

export default useScrollHelper;
